/**
 * Formulaire inline de création rapide d'une action spontanée (affiché dans la fiche contact).
 */

import React, { useEffect, useState } from "react";
import { createAction } from "../api/spontaneousActionApi";
import { getTags, createTag } from "../api/tagApi";
import { getUsers } from "../api/userApi";
import { useAuth } from "../contexts/AuthContext";
import TagSelector from "./TagSelector";
import { todayISO } from "../utils/dateUtils";

export default function InlineActionForm({ contactId, onCreated, onCancel }) {
  const { user } = useAuth();
  const [allTags, setAllTags] = useState([]);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    action_date: todayISO(),
    description: "",
    responsable_user_id: user?.id ? String(user.id) : "",
    tag_ids: [],
  });

  useEffect(() => {
    getTags().then(setAllTags);
    getUsers().then(setUsers);
  }, []);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleCreateTag(label) {
    const tag = await createTag(label);
    setAllTags([...allTags, tag]);
    setForm({ ...form, tag_ids: [...form.tag_ids, tag.id] });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    try {
      await createAction({
        contact_id: contactId,
        action_date: form.action_date || null,
        description: form.description,
        responsable_user_id: form.responsable_user_id ? Number(form.responsable_user_id) : null,
        tag_ids: form.tag_ids,
      });
      onCreated();
    } catch {
      setError("Erreur lors de la création de l'action.");
    }
  }

  return (
    <div className="inline-form-card">
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Date</label>
            <input type="date" name="action_date" value={form.action_date} onChange={handleChange} />
          </div>
          <div className="form-group" />
        </div>
        <div className="form-group">
          <label>Responsable</label>
          <select name="responsable_user_id" value={form.responsable_user_id} onChange={handleChange}>
            {users.map((u) => (
              <option key={u.id} value={u.id}>
                {u.last_name} {u.first_name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>Description</label>
          <textarea name="description" value={form.description} onChange={handleChange} placeholder="Description de l'action..." />
        </div>
        <div className="form-group">
          <label>Tags</label>
          <TagSelector
            allTags={allTags}
            selectedIds={form.tag_ids}
            onChange={(ids) => setForm({ ...form, tag_ids: ids })}
            onCreateTag={handleCreateTag}
          />
        </div>
        <div className="form-actions">
          <button type="submit" className="btn btn-primary btn-small">Créer l'action</button>
          <button type="button" className="btn btn-secondary btn-small" onClick={onCancel}>Annuler</button>
        </div>
      </form>
    </div>
  );
}
